import {ApiClient} from '@hconnect/apiclient'
import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'

type Params = {
  plantId: string
  options?: UseMutationOptions<unknown, AxiosError, string>
}

export const useTaskScheduleDelete = ({plantId, options}: Params) => {
  const queryClient = useQueryClient()
  return useMutation<unknown, AxiosError, string>({
    mutationFn: async (taskId: string) => {
      const path = `/shifthandover/${plantId}/tasks/schedules?taskId=${taskId}`
      const response = await ApiClient.axiosInstance.delete(path)
      return response.data
    },
    // allow the caller to override the default options
    ...options,

    // make sure to invalidate the Queries after the regular onSuccess process is done
    onSuccess: async (data, variables, context, mutation) => {
      await queryClient.invalidateQueries()
      await options?.onSuccess?.(data, variables, context, mutation)
    }
  })
}
